import type { CustomerBreachNotice } from '@/lib/breachNotifications';

export const BREACH_ACKNOWLEDGEMENT_COUNT_CHANGED_EVENT = 'supplyguard:breach-acknowledgement-count-changed';

export function breachAcknowledgementCountQueryKey(organizationId: string | null | undefined) {
  return ['breach-acknowledgement-count', organizationId ?? 'none'] as const;
}

export function isBreachAcknowledgementRequired(notice: CustomerBreachNotice) {
  const breachCase = notice.breach_notification_cases;
  const isResolved = notice.customer_status === 'resolved'
    || notice.customer_status === 'not_applicable'
    || Boolean(breachCase?.resolved_at)
    || breachCase?.status === 'closed';

  return !isResolved && !notice.acknowledged_at;
}

export function getBreachAcknowledgementCount(notices: CustomerBreachNotice[]) {
  return notices.filter(isBreachAcknowledgementRequired).length;
}

export function notifyBreachAcknowledgementCountChanged() {
  window.dispatchEvent(new Event(BREACH_ACKNOWLEDGEMENT_COUNT_CHANGED_EVENT));
}
